import { Button, Collapse, Divider, Grid, Paper, Skeleton, Stack, Typography } from "@mui/material"
import React from "react"
import { AdjustmentCouponGet } from "../../Objects/AdjustmentCouponGet"

export interface AdjustmentCouponGetListProps {
    adj_coupon_get?: AdjustmentCouponGet[]
}
const AdjustmentCouponGetList: React.FC<AdjustmentCouponGetListProps> = ({
    adj_coupon_get
}) => {
    const [showDetail, setShowDetail] = React.useState<boolean>(false)

    return (
        <Paper
            variant="outlined"
            sx={{
                p: 2,
                pt: 1
            }}
        >
            <Stack
                spacing={1}
            >
                <Collapse
                    in={showDetail}
                >
                    <Stack
                        spacing={1}
                        sx={{
                            pt: 1
                        }}
                    >
                        {adj_coupon_get ? adj_coupon_get.map((adjustment, index) => (
                            <Grid container key={index}
                                sx={{
                                    px: 2
                                }}
                            >
                                <Grid item xs={10} sm={5}>
                                    <Typography textAlign="left">{adjustment.item}</Typography>
                                </Grid>
                                <Grid item xs={2} sm={2}>
                                    <Typography textAlign="right">×{adjustment.number}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <Typography textAlign="right">{adjustment.charge.toLocaleString()} Pt</Typography>
                                </Grid>
                            </Grid>
                        )) : (
                            <Skeleton variant="rectangular" height={50} />
                        )}
                        {adj_coupon_get && adj_coupon_get.length > 0 &&
                            <Divider />
                        }
                    </Stack>
                </Collapse>
                <Grid container
                    sx={{
                        px: 2
                    }}
                >
                    <Grid item xs={10} sm={5}>
                        <Typography textAlign="left" color="primary" fontWeight="bold">
                            付与ポイント合計
                            <Button size="small"
                                onClick={() => {
                                    setShowDetail(prev => !prev)
                                }}
                            >詳細</Button>
                        </Typography>
                    </Grid>
                    <Grid item xs={2} sm={2}>
                        <Typography textAlign="right">×{adj_coupon_get ? adj_coupon_get.reduce<number>((prev, adjustment) => prev + adjustment.number, 0) : "-"}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={5}>
                        <Typography textAlign="right">{adj_coupon_get ? adj_coupon_get.reduce<number>((prev, adjustment) => prev + adjustment.charge, 0).toLocaleString() : "-"} Pt</Typography>
                    </Grid>
                </Grid>
            </Stack>
        </Paper>
    )
}

export default AdjustmentCouponGetList